import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/img/exam-title.png'


const _hoisted_1 = { class: "examhome-wrapper" }
const _hoisted_2 = { class: "exam-content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "exam-title",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "exam-info" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "exam-time" }, "考试时间：2022年11月5日（周六）8:00～20:00", -1)
const _hoisted_6 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareBtn = _resolveComponent("ShareBtn")
  const _component_HomeModal = _resolveComponent("HomeModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", {
          class: "exam-begin",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routerLinkTo('/exam')))
        }),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "exam-mine",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.routerLinkTo('/myscore')))
          })
        ])
      ])
    ]),
    _createVNode(_component_ShareBtn),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_HomeModal, {
          key: 0,
          btnText: _ctx.btnText,
          onCallback: _ctx.callBackFn,
          modalText: _ctx.modalText
        }, null, 8, ["btnText", "onCallback", "modalText"]))
      : _createCommentVNode("", true)
  ]))
}